module.exports = __webpack_public_path__ + "static/media/us-flag.2b29a939.png";